import { withStyles } from '@material-ui/core';

const Styled = (component, styles = {}) => withStyles(styles)(component);

export default Styled;
